export default __webpack_public_path__ + "static/generative-border-dark-d739bf4410e1a6a45ed681cc78cac68f.png";